(() => {
  'use strict';

  function parseMoneyCents(value) {
    const normalized = String(value || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function syncPrintPresentation(root) {
    if (!root || !root.matches('[data-srd-print-product]')) return;

    const shippingTotal = root.querySelector('[data-srd-savings-total]');
    const liveTotal = root.querySelector('[data-srd-print-live-total]');
    const normalizedTotal = shippingTotal?.textContent.trim();
    if (normalizedTotal && liveTotal && liveTotal.textContent.trim() !== normalizedTotal) {
      liveTotal.textContent = normalizedTotal;
    }

    const progress = root.querySelector('[data-srd-visual-free-progress]');
    if (progress && shippingTotal) {
      const maximum = Number(progress.max || 3500);
      const nextValue = Math.min(maximum, Math.max(0, parseMoneyCents(shippingTotal.textContent)));
      if (progress.value !== nextValue) progress.value = nextValue;
    }
  }

  function quantityInput(root) {
    return root.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      root.querySelector('quantity-input input[name="quantity"]') ||
      root.querySelector('input[name="quantity"]');
  }

  function persistQuantity(root) {
    const input = quantityInput(root);
    const quantity = Math.max(1, Math.floor(Number(input?.value || 1)));
    const state = history.state && typeof history.state === 'object' ? history.state : {};
    history.replaceState({ ...state, srdPrintQuantity: quantity }, '', location.href);
  }

  function restoreQuantity(root) {
    const restored = Number(history.state?.srdPrintQuantity);
    const input = quantityInput(root);
    if (!input || !Number.isFinite(restored) || restored < 1) return;
    const normalized = String(Math.floor(restored));
    if (input.value !== normalized) input.value = normalized;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init(root) {
    restoreQuantity(root);
    syncPrintPresentation(root);
    root.addEventListener('input', (event) => {
      if (event.target.matches('input[name="quantity"]')) persistQuantity(root);
    });
    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name="quantity"]')) persistQuantity(root);
    });
    const observer = new MutationObserver(() => syncPrintPresentation(root));
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function initAll() {
    document.querySelectorAll('[data-srd-print-product]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-srd-print-product]').forEach((root) => {
      restoreQuantity(root);
      syncPrintPresentation(root);
    });
  });
})();
